<template>
  <v-app>
    <v-main class="grey lighten-4">
      <!-- <v-img
        height="100vh"
        min-height="100vh"
        lazy-src="/img/img_login.jpg"
        src="/img/img_login.jpg"
        gradient="to top right, rgba(0,0,0,0.5), rgba(0,0,0,0.5)"
      > -->
      <v-container fill-height>
        <v-row class="fill-height_" justify="center" align_="center">
          <v-col cols="12" sm="6" md="6" lg="4" xl="3" align="center">
            <v-slide-y-transition>

              <v-card v-show="show" elevation="24" class="rounded-lg">
                <template v-if="disabled_username">
                  <v-alert class="mt-3 mb-0 rounded-b-0" dense text color="#2A3B4D">
                    Sistema bloqueado por inatividade. <br>Por favor, informe sua senha para continuar.
                  </v-alert>
                  <v-divider></v-divider>
                </template>
                <!-- <h1>Tela travada por inatividade</h1> -->
                <!-- <v-card-text>
                    <v-row justify="center">
                      <img src="static/organize-verde/96x96.png">
                    </v-row>
                  </v-card-text> -->

                <v-container class="pa-6">
                  <v-form v-model="form_valido" ref="form">
                    <v-row justify="center" class="mb-5">
                      <h1 class="headline">Acesso ao Sistema</h1>
                    </v-row>
                    <v-row justify="center" class="mb-8">
                      <v-avatar color="primary" size="100">
                        <v-icon dark size="70">mdi-lock</v-icon>
                      </v-avatar>
                    </v-row>
                    <v-row justify="center" dense class="mb-3">
                      <v-col cols="12" sm="12" md="12">
                        <v-text-field
                          v-model="usuario.email"
                          ref="usuario"
                          color="primary"
                          label="Usuário"
                          filled
                          dense
                          required
                          autofocus
                          placeholder=" "
                          prepend-inner-icon="mdi-account"
                          :rules="regras.email"
                          :error="erros.email.length > 0"
                          :error-messages="erros.email"
                          :disabled="disabled_username"
                          append-icon="mdi-sync"
                        >
                          <template #append>
                            <v-tooltip bottom>
                              <template #activator="{ on, attrs }">
                                <v-icon @click="trocarUsuario" v-bind="attrs" v-on="on">mdi-sync</v-icon>
                              </template>
                              <span>Trocar de usuário</span>
                            </v-tooltip>
                          </template>
                        </v-text-field>
                      </v-col>
                      <v-col cols="12" sm="12" md="12">
                        <v-text-field
                          v-model="usuario.password"
                          ref="senha"
                          color="primary"
                          label="Senha"
                          filled
                          dense
                          placeholder=" "
                          prepend-inner-icon="mdi-lock"
                          required
                          :append-icon="mostrar_senha ? 'mdi-eye' : 'mdi-eye-off'"
                          :type="mostrar_senha ? 'text' : 'password'"
                          :rules="regras.password"
                          :error="erros.password.length > 0"
                          :error-messages="erros.password"
                          @click:append="mostrar_senha = !mostrar_senha"
                          @keypress.enter="login"
                        ></v-text-field>
                      </v-col>
                    </v-row>

                    <v-row justify="center" dense>
                      <v-col align="center">
                        <v-btn
                          block_
                          min-width="200px"
                          rounded
                          color="primary"
                          dark
                          @click="login"
                          >Entrar</v-btn
                        >
                      </v-col>
                    </v-row>
                    <v-col cols="12" class="text-center text-caption pa-0">
                      {{ config.APP_VERSION }}
                    </v-col>

                  </v-form>
                </v-container>
              </v-card>
            </v-slide-y-transition>
          </v-col>
        </v-row>
      </v-container>
      <!-- </v-img> -->
    </v-main>

    <z-aguardar ref="aguardar" color="primary"></z-aguardar>
  </v-app>
</template>

<script>
// import UsuariosService from '../services/usuarios';

import config from "@/app/config";

export default {
  data() {
    return {
      usuario: {
        email: "",
        password: "",
      },
      erros: {
        email: [],
        password: [],
      },
      dialog: false,
      form_valido: false,
      regras: {
        email: [(v) => !!v || "Informar o nome do usuário"],
        password: [(v) => !!v || "Informar a senha do usuário"],
      },
      mostrar_senha: false,
      show: false,
      disabled_username: false,
      redirect: null,
      config,
    };
  },

  mounted() {
    // this.$auth.csrf();

    if (!config.IS_PRODUCTION) {
      this.usuario = {
        email: "admin",
        password: "superadmin@123.",
      };
    }

    if (this.$route.query.user) {
      this.usuario.email = this.$route.query.user;
      this.disabled_username = true;
      setTimeout(() => {
        this.$refs.senha.focus();
      }, 100);
    } else {
      setTimeout(() => {
        this.$refs.usuario.focus();
      }, 100);
    }

    if (this.$route.query.redirect) {
      this.redirect = this.$route.query.redirect;
    }

    this.show = true;
    this.carregarLoja();
  },
  methods: {
    async login() {
      // this.ativarRegras();

        if (!this.$refs.form.validate()) {
          return;
        }

        try {
          this.zerarErros();
          this.$refs.aguardar.abrir();

          await this.$auth.login(this.usuario);

          if (this.redirect) {
            this.$router.push(this.redirect);
            return;
          }

          this.$router.push({ path: "/" });
          
        } catch (error) {
          // this.limparForm();
          this.$auth.logout();
          // this.erros.password.push("Usuário ou senha inválidos");
          this.exibirErrosServidor();
          this.$refs.senha.focus();
        } finally {
          this.$refs.aguardar.fechar();
        }

    },

    trocarUsuario() {
      this.$router.push('/login');
    },

    zerar() {
      this.usuario = {
        email: "",
        password: "",
      };
    },

    zerarErros() {
      this.erros = {
        email: [],
        password: [],
      };
    },

    ativarRegras() {
      this.regras = {
        email: [
          (v) => !!v || "O campo email é obrigatório",
          (v) =>
            /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(v) ||
            "O campo e-mail é inválido",
        ],
        password: [
          (v) => !!v || "O campo senha é obrigatório",
          // (v) => v && v.length >= 4 || 'Mínimo 4 caracteres'
        ],
      };
    },

    processarErrosServidor(erros) {
      if (erros.email) {
        this.erros.email = erros.email;
        console.log("Erro no email: ", this.erros.email);
      }
      if (erros.password) {
        this.erros.password = erros.password;
        console.log("Erro no password");
      }
    },

    exibirErrosServidor() {
      this.erros.password.push("Usuário ou senha inválidos");
      setTimeout(() => {
        this.erros.password = [];
      }, 3000);
    },

    limparForm() {
      this.$refs.form.reset();
      this.regras = {};
    },

    carregarLoja() {
      let loja = this.$storage.get('loja');
      if (loja) {
        this.$store.commit('lojas/SET_LOJA_ATUAL', loja);
        this.$vuetify.theme.themes.light.primary = loja.cor_primaria;
      }
    },

  },
};
</script>

<style>
.topo {
  margin-top: 50px;
}
</style>
